// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__X6ThB"};